const { REACT_APP_API_ENDPOINT } = process.env;

export const apiUrl = `${REACT_APP_API_ENDPOINT}/graphql/`;
